import type { Organization, Practitioner, Reference } from '@medplum/fhirtypes'
import { parseReferenceString } from '@seen/core/utils'

import { cn, TypographyDetail, TypographySubtle } from '@seen/ui'
import type { JSX } from 'react'
import { HoverOrganization } from '#src/components/core/hover-card/HoverOrganization.tsx'
import { HoverPractitioner } from '#src/components/core/hover-card/HoverPractitioner.tsx'
import { TaskRowCheckbox } from '#src/components/TaskRowCheckbox.tsx'

export interface OrderPerformerGroupHeaderProps {
  performer: string | null
  orderCount: number
  hideCheckbox?: boolean
  checked?: boolean
  onCheckedChange?: (value: boolean) => void
}

export function OrderPerformerGroupHeader({
  performer: performerReferenceString,
  orderCount,
  hideCheckbox,
  checked,
  onCheckedChange,
}: OrderPerformerGroupHeaderProps): JSX.Element {
  const performerRef = performerReferenceString
    ? parseReferenceString(performerReferenceString)
    : null
  const isOrg = performerRef?.type === 'Organization'
  const isPractitioner = performerRef?.type === 'Practitioner'

  return (
    <div
      className={cn(
        'group flex h-10 items-center justify-between',
        'bg-frame',
        'px-pagex-default lg:px-pagex-lg',
        !hideCheckbox && 'pr-8 pl-0 lg:pr-8 lg:pl-0'
      )}
    >
      {!hideCheckbox && (
        <TaskRowCheckbox value={checked} onChange={onCheckedChange} />
      )}
      <div className="flex flex-1 items-center gap-2">
        {isPractitioner && performerReferenceString && (
          <HoverPractitioner
            practitioner={performerRef as Reference<Practitioner>}
          />
        )}
        {isOrg && performerReferenceString && (
          <HoverOrganization
            organization={performerRef as Reference<Organization>}
          />
        )}
        {!performerReferenceString && (
          <TypographySubtle>No performer</TypographySubtle>
        )}
        <TypographyDetail className="text-foreground-secondary">
          ({orderCount})
        </TypographyDetail>
      </div>
    </div>
  )
}
